import { render, staticRenderFns } from "./returnQty.vue?vue&type=template&id=4bfbc236&scoped=true"
import script from "./returnQty.vue?vue&type=script&lang=js"
export * from "./returnQty.vue?vue&type=script&lang=js"
import style0 from "./returnQty.vue?vue&type=style&index=0&id=4bfbc236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbc236",
  null
  
)

export default component.exports